module.exports = __webpack_public_path__ + "static/roman-b3e8e2cb6f4d382fadcb8f9d68606bd6.gif";